import { Command } from 'common/Prose/Commands'
import { schema as nerudaSchema } from 'prose-core'

/**
 * If your cursor is at the first position inside the toggle block body and you press backspace, do nothing
 * otherwise it will try to join the body with the summary or select the whole node
 */
export const preventToggleBlockSelectBackward: Command = ({ selection: { $from, empty } }) => {
  if (empty && $from.node(-1)?.type === nerudaSchema.nodes.toggle_list && $from.parentOffset === 0) {
    return true
  }
  return false
}
